var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3615 8.99495C16.9452 8.99495 16.6078 9.33237 16.6078 9.74869V18.4911L1.50855 18.4685L1.53164 3.36683H10.2764C10.6924 3.36683 11.0301 3.02941 11.0301 2.61304C11.0301 2.19667 10.6927 1.85925 10.2764 1.85925H0.778906C0.363086 1.85925 0.0258989 2.19593 0.0251177 2.61175L5.20886e-07 19.2198C-0.000233854 19.4198 0.0786332 19.6118 0.220117 19.7532C0.361055 19.8949 0.552773 19.9746 0.752773 19.9748L17.3605 20C17.361 20 17.3613 20 17.3618 20C17.5615 20 17.753 19.9206 17.8942 19.7796C18.0359 19.6384 18.1153 19.4465 18.1153 19.2462V9.74873C18.1153 9.33241 17.7779 8.99495 17.3615 8.99495Z",
    fill: "#219EBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2463 0H13.8192C13.4029 0 13.0654 0.337421 13.0654 0.753788C13.0654 1.17012 13.4029 1.50754 13.8192 1.50754H18.4926V6.20601C18.4926 6.62233 18.83 6.95976 19.2463 6.95976C19.6626 6.95976 20.0001 6.62233 20.0001 6.20601V0.753788C20.0001 0.337421 19.6627 0 19.2463 0Z",
    fill: "#219EBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7791 0.220869C19.4847 -0.0736229 19.0077 -0.0736229 18.7133 0.220869L9.01478 9.91933C8.72033 10.2135 8.72033 10.6909 9.01478 10.9852C9.16178 11.1324 9.35474 11.206 9.54771 11.206C9.74068 11.206 9.93365 11.1324 10.0806 10.9852L19.7791 1.28669C20.0736 0.992469 20.0736 0.515087 19.7791 0.220869Z",
    fill: "#219EBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.1bb03a344ea2ba8e8f789682928ea3cc.svg";
export { ForwardRef as ReactComponent };